import { useState } from 'react';
import type { UserIdAndName } from '../types/user.types';

export function useUserActionModals() {
  const [userToResetPassword, setUserToResetPassword] = useState<UserIdAndName | null>(null);
  const [userToDelete, setUserToDelete] = useState<UserIdAndName | null>(null);

  return {
    userToResetPassword,
    userToDelete,
    openResetPasswordModal: setUserToResetPassword,
    openDeleteModal: setUserToDelete,
    closeResetPasswordModal: () => setUserToResetPassword(null),
    closeDeleteModal: () => setUserToDelete(null),
  };
}
